AOS.init({
  duration: 250,
  easing: 'ease',
  once: false,
  mirror: false,
  anchorPlacement: 'top-bottom'
});
const tab_swiper_product_seller = new Swiper(".tab-collection-grid-slider", {
  direction: "horizontal",
  slidesPerView: 1.3,
  loop: true,
  spaceBetween: 20,
  pagination: {el: ".swiper-pagination"},
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  scrollbar: {el: ".swiper-scrollbar"},
  autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
  breakpoints: {
    600: {
      slidesPerView: 2.1,
      spaceBetween: 27
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 35
    },
    989: {
      slidesPerView: 3,
      spaceBetween: 40
    },
    1299: {
      slidesPerView: 3,
      spaceBetween: 70
    }
  }
});
const swiper_product_seller = new Swiper(".collection-grid-slider", {
  direction: "horizontal",
  slidesPerView: 1.2,
  loop: true,
  spaceBetween: 20,
  pagination: {el: ".swiper-pagination"},
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  scrollbar: {el: ".swiper-scrollbar"},
  autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
  breakpoints: {
    600: {
      slidesPerView: 2.2,
      spaceBetween: 27
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 40
    },
    989: {
      slidesPerView: 3,
      spaceBetween: 40
    },
    1299: {
      slidesPerView: 3,
      spaceBetween: 70
    }
  }
});
const swiper_blog_article = new Swiper(".blog-article-area", {
  direction: "horizontal",
  slidesPerView: 1.2,
  loop: true,
  spaceBetween: 20,
  pagination: {el: ".article-swiper-pagination"},
  navigation: {
    nextEl: ".article-swiper-button-next",
    prevEl: ".article-swiper-button-prev"
  },
  scrollbar: {el: ".swiper-scrollbar"},
  autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
  breakpoints: {
    768: {
      slidesPerView: 2.2,
      spaceBetween: 20
    },
    999: {
      slidesPerView: 3,
      spaceBetween: 36
    }
  }
});
const testomonial_swiper_slide = new Swiper('.testimonial-slider-block', {
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 20,
  loopedSlides: 10,
  centeredSlides: true,
  pagination: {el: ".test-swiper-pagination"},
  autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
  /*effect: 'coverflow',
  coverflowEffect: {
    rotate: 0,
    stretch: 40,
    depth: 40,
    modifier: 1.5,
    slideShadows : false,
  },*/
  scrollbar: '.js-swiper-scrollbar'
});

function article_matchheight() {
  var i = 0;
  var items = document.querySelectorAll(".article-card-contant");
  var itemsHeight = [];
  for (i = 0; i < items.length; i++) {
    itemsHeight.push(items[i].offsetHeight);
  }
  var maxHeight = Math.max(...itemsHeight);
  for (i = 0; i < items.length; i++) {
    items[i].style.height = maxHeight + "px";
  }
}
article_matchheight();

var connectTabs = new Tabs();

const accSingleTriggers = document.querySelectorAll('.accordian-title');
accSingleTriggers.forEach(trigger => trigger.addEventListener('click', toggleAccordion));
function toggleAccordion() {
  const items = document.querySelectorAll('.accordian--toggle');
  const thisItem = this.parentNode;
  items.forEach(item => {
    if (thisItem == item) {
      thisItem.classList.toggle('is-open');
      return;
    }
    item.classList.remove('is-open');
  });
}
const pdp_accSingleTriggers = document.querySelectorAll('.pdp-meta-label');
pdp_accSingleTriggers.forEach(pdp_trigger => pdp_trigger.addEventListener('click', pdp_toggleAccordion));
function pdp_toggleAccordion() {
  const pdp_items = document.querySelectorAll('.pdp-accordion');
  const pdp_thisItem = this.parentNode;
  pdp_items.forEach(pdp_item => {
    if (pdp_thisItem == pdp_item) {
      pdp_thisItem.classList.toggle('is-open');
      return;
    }
    pdp_item.classList.remove('is-open');
  });
}

const faq_accSingleTriggers = document.querySelectorAll('.tab_section');
faq_accSingleTriggers.forEach(faq_trigger => faq_trigger.addEventListener('click', faq_toggleAccordion));
function faq_toggleAccordion() {
  const faq_items = document.querySelectorAll('.product_set');
  const faq_thisItem = this.parentNode;
  faq_items.forEach(faq_item => {
    if (faq_thisItem == faq_item) {
      faq_thisItem.classList.toggle('is-open');
      return;
    }
    faq_item.classList.remove('is-open');
  });
}
/*window.addEventListener("resize", function() {
  if (window.matchMedia("(min-width: 769px)").matches) {} else {
    const swiper_richtext_article_resize = new Swiper(".body-block-contant", {
      slidesPerView: 2.4,
      loop: true,
      spaceBetween: 15,
      pagination: {
        el: '.swiper-scrollbar-pagination',
      },
      breakpoints: {
          575: {
            slidesPerView: 4.2,
            spaceBetween: 27,
          }
      }
    });
  }
});*/
if (window.matchMedia("(min-width: 769px)").matches) {} else {
  const swiper_richtext_article = new Swiper(".body-block-contant", {
    loop: true,
    slidesPerView: 2.4,
    spaceBetween: 15,
    loopedSlides: 10,
    pagination: {el: ".swiper-scrollbar-pagination"},
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
    breakpoints: {
      575: {
        slidesPerView: 4.2,
        spaceBetween: 27,
      }
    }
  });
}

// const galleryThumbs = new Swiper ('.gallery-thumbs', {
//  centeredSlides: false,
//   centeredSlidesBounds: true,
//   slidesPerView: 5,
//   loop: false,
//   spaceBetween: 15,
//   allowTouchMove: false,
//   watchOverflow: true,
//   watchSlidesVisibility: true,
//   watchSlidesProgress: true,
//   direction: 'horizontal',
//   breakpoints: {
//       480: {
//         direction: "horizontal",
//         slidesPerView: 5
//       }
//     }
  
// });

// const pdp_product_slider = new Swiper(".slider-mobile-gutter", {
//   watchOverflow: true,
//   watchSlidesVisibility: true,
//   watchSlidesProgress: true,
//   preventInteractionOnTransition: true,
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
//   effect: 'fade',
//     fadeEffect: {
//     crossFade: true
//   },
//   thumbs: {
//     swiper: galleryThumbs
//   }
// });

// pdp_product_slider.on('slideChangeTransitionStart', function() {
//   galleryThumbs.slideTo(pdp_product_slider.activeIndex);
// });

// galleryThumbs.on('transitionStart', function(){
//   galleryMain.slideTo(galleryThumbs.activeIndex);
// });






const pdp_product_meta_slider = new Swiper(".pdp-slider-area", {
  direction: "horizontal",
  slidesPerView: 1,
  loop: true,
  navigation: {
    nextEl: ".meta-swiper-button-next",
    prevEl: ".meta-swiper-button-prev"
  },
  autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
  scrollbar: {
    el: ".swiper-scrollbar"
  }
});
(function() {
  var button = document.querySelector('.facet-filters__label-1');
  var list_toggles = document.querySelector('.dropdown-variant');
  var button_2 = document.querySelector('.facet-filters__label-3');
  var list_toggle_2 = document.querySelector('.dropdown-variant-3');
  var button_1 = document.querySelector('.facet-filters__label-2');
  var list_toggle_1 = document.querySelector('.dropdown-variant-2');
  var body_class = document.querySelector('body');
  if (button) {
    button.addEventListener('click', function() {

      if(button_2){
      button_2.classList.remove('open-dropdown');
      list_toggle_2.classList.remove('toggle-dropdown');
      button_2.parentElement.classList.remove('new-class');
      }

      if(button_1){
      button_1.classList.remove('open-dropdown');
      list_toggle_1.classList.remove('toggle-dropdown');
      button_1.parentElement.classList.remove('new-class');
      }

      if(button){
      button.classList.toggle('open-dropdown');
      list_toggles.classList.toggle('toggle-dropdown');
      button.parentElement.classList.toggle('new-class');
       
      }
    });
    var drop_down_close = document.querySelectorAll('.dropdown-variant-values');
    drop_down_close.forEach(drop_down_trigger => drop_down_trigger.addEventListener('click', toggleAccordion_close));
    function toggleAccordion_close() {
      list_toggles.classList.remove('toggle-dropdown');
      button.classList.remove('open-dropdown');
      button.parentElement.classList.remove('new-class');
    }
  }
})();
(function() {
  var button_1 = document.querySelector('.facet-filters__label-2');
  var list_toggle_1 = document.querySelector('.dropdown-variant-2');
  var button = document.querySelector('.facet-filters__label-1');
  var list_toggles = document.querySelector('.dropdown-variant');
  var button_2 = document.querySelector('.facet-filters__label-3');
  var list_toggle_2 = document.querySelector('.dropdown-variant-3');
  var body_class = document.querySelector('body');
  if (button_1) {
    button_1.addEventListener('click', function() {

      if(button_2) {
      button_2.classList.remove('open-dropdown');
      list_toggle_2.classList.remove('toggle-dropdown');
      button_2.parentElement.classList.remove('new-class');
      }

      if(button){
      button.classList.remove('open-dropdown');
      list_toggles.classList.remove('toggle-dropdown');
      button.parentElement.classList.remove('new-class');
      }
      
      button_1.classList.toggle('open-dropdown');
      list_toggle_1.classList.toggle('toggle-dropdown');
      button_1.parentElement.classList.toggle('new-class');
       
    });
    var drop_down_close_1 = document.querySelectorAll('.dropdown-variant-values');
    drop_down_close_1.forEach(drop_down_trigger_1 => drop_down_trigger_1.addEventListener('click', toggleAccordion_close_1));
    function toggleAccordion_close_1() {
      list_toggle_1.classList.remove('toggle-dropdown');
      button_1.classList.remove('open-dropdown');
      button_1.parentElement.classList.remove('new-class');
    }
  }
})();

(function() {
  var button_2 = document.querySelector('.facet-filters__label-3');
  var list_toggle_2 = document.querySelector('.dropdown-variant-3');
  var button_1 = document.querySelector('.facet-filters__label-2');
  var list_toggle_1 = document.querySelector('.dropdown-variant-2');
  var button = document.querySelector('.facet-filters__label-1');
  var list_toggles = document.querySelector('.dropdown-variant');
  var body_class = document.querySelector('body');
  if (button_2) {
    button_2.addEventListener('click', function(e) {
      e.preventDefault();
      
      if(button_1) {
      button_1.classList.remove('open-dropdown');
      list_toggle_1.classList.remove('toggle-dropdown');
      button_1.parentElement.classList.remove('new-class');
      }

      if(button){
      button.classList.remove('open-dropdown');
      list_toggles.classList.remove('toggle-dropdown');
      button.parentElement.classList.remove('new-class');
      }
      
      button_2.classList.add('open-dropdown');
      list_toggle_2.classList.add('toggle-dropdown');
      button_2.parentElement.classList.add('new-class');
      body_class.classList.add('var-list-body-class');
       
      console.log('ifff');
      return false;
    });
    var drop_down_close_2 = document.querySelectorAll('.dropdown-variant-values');
    drop_down_close_2.forEach(drop_down_trigger_2 => drop_down_trigger_2.addEventListener('click', toggleAccordion_close_2));
    function toggleAccordion_close_2() {
      list_toggle_2.classList.remove('toggle-dropdown');
      button_2.classList.remove('open-dropdown');
      button_2.parentElement.classList.remove('new-class');
      body_class.classList.remove('var-list-body-class');
      console.log('elseee');
    }
  }
})();

$( document ).ready(function() {
  
  $('.deferred-media__poster').trigger('click');

  var banner_slider_index = new Swiper('.swiper-banner-slider', {
    loop: true,
    spaceBetween: 50,
    speed: 1000,
    pagination: {el: ".swiper-pagination"},
    autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });

  $('.product__desc-read-more').click(function() {
    $('.product__description-more').toggleClass('short-desc', 1000);
    if ($('.product__description-more').hasClass('short-desc')) {
      $('.product__desc-read-more').text('Read More');
    } else {
      $('.product__desc-read-more').text('Read Less');
    }
  });

  var current_variant = $('.form-flavour-label label').text();
   var size_up_var = $('.form-flavour-label-size label').text();
  var current_variant_handle = current_variant.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  var update_variant_handle_size = size_up_var.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');


 var thir_t = $('.product-form__input:nth-child(3) .form-flavour-label label').text();
 var thir_t_size = thir_t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');



  
    var length_c = $('.form-flavour-label-size-count li').length;
  var media_c = $('.media-gallery-image.position--3d-img').length;

  console.log('thir_t',thir_t)

    if(length_c > 1){
      if(thir_t != '' || thir_t != ' '){
        console.log('ifffff')
     current_variant_handle = current_variant_handle+'-'+update_variant_handle_size
      }else{
        console.log('elseeee')
        current_variant_handle = current_variant_handle+'-'+thir_t_size+'-'+update_variant_handle_size;
      }
      console.log('current_variant_handle',current_variant_handle)
    }else{
      current_variant_handle = current_variant_handle;
      if(media_c > 1){
        $('.media-gallery-image.position--3d-img').removeClass('first-pdp-li')
      }
    }

  
  
  console.log(current_variant_handle)
  $('.var-'+current_variant_handle).show();
  setTimeout(() => {
    $('.hide3d-msg.var-'+current_variant_handle).show();
  }, 1000);
});

$(document).scroll(function() {
  var offsetTop = $('.footer-section-blocks').offset().top - 470;
  if($(window).scrollTop() > offsetTop){
    $('.sticky-add-cart-mobile').hide();
  } else {
    $('.sticky-add-cart-mobile').show();
  }
});

// $(document).ready(function() {
//     // Initialize Swiper
//     var mySwiper = new Swiper('.swiper-container', {
//         pagination: {
//             el: '.swiper-pagination',
//             clickable: true,
//         },
//         navigation: {
//             nextEl: '.swiper-button-next',
//             prevEl: '.swiper-button-prev',
//         },
//     });

//     $('.product__info-container variant-radios fieldset ul li label').on('click', function(){
//         var data_join = '';

//         // Gather the selected values
//         setTimeout(function(){
//             $('.product__info-container variant-radios fieldset').each(function(){
//                 var selectedValue = $(this).find('input:checked').attr('data-value');
//                 if (data_join != '') {
//                     data_join += '-' + selectedValue;
//                 } else {
//                     data_join = selectedValue;
//                 }
//             });

//             console.log('data_join', data_join);

//             // Filter the swiper slides
//             $('.swiper-wrapper .swiper-slide').each(function(){
//                 var slide = $(this);

//               $('.swiper-slide').addClass('hidden');
//               $('.wc-cola-lime-250-gm').removeClass('hidden');
//               $('.wc-all').removeClass('hidden');
              
//                 // if (slide.hasClass(data_join) || slide.hasClass('all')) {
//                 //     slide.removeClass('hidden');
//                 // } else {
//                 //     slide.addClass('hidden');
//                 // }
//             });

//             // Update Swiper after filtering
//            // mySwiper.update();
//             // mySwiper.updateSize();
//             // mySwiper.updateSlides();
//             // mySwiper.updateSlidesClasses();
//             // mySwiper.slideTo(0);

//         }, 200); // Adjust the timeout delay if necessary
//     });
// });


/*(function() {
  'use strict';

  const stickyContainer = document.getElementById('sticky-container');
  const observer = new IntersectionObserver(handleIntersection, {
    threshold: 0.1
  });

  document.querySelectorAll('[data-hide-sticky]').forEach(target => {
    observer.observe(target);
  })

  function handleIntersection(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        stickyContainer.classList.remove('sticky-add-cart');
      }
      else {
        stickyContainer.classList.add('sticky-add-cart');
      }
    })
  }
})();*/


// $("body").click(function(event){
//     var $target = $(event.target);
//     if(!$target.is(".var-list-body-class")){
//         $("body").removeClass('var-list-body-class');
//       $('.facet-filters__label').removeClass('open-dropdown');
//       $('.position-relative').removeClass('new-class');
//       $('.dropdown-variant').removeClass('toggle-dropdown');
       
//     }
//   return false;
// });

// $('.facet-filters__label').on('click', function(event){
//   $('.facet-filters__label').removeClass('open-dropdown');
//       $('.position-relative').removeClass('new-class');
//       $('.dropdown-variant').removeClass('toggle-dropdown');
//       $(this).addClass('open-dropdown');
//       $(this).parent('.position-relative').addClass('new-class');
//       $(this).parent('.position-relative').find('.dropdown-variant').addClass('toggle-dropdown');
//   console.log('ifffffffffff');
//   $("body").addClass('var-list-body-class');
  
// })

















